<template>
  <div class="col-md-12">
    <!-- <h4 style="margin-top:5px;">Animal Details
       <b-button variant="danger" @click="handleBack">
                    <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
                </b-button>
    </h4> -->
    <h4 style="margin-top: 5px">
      Animal Details
      <b-button class="float-right" @click="handleBack" variant="danger">
        <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
      </b-button>
    </h4>

    <hr />

    <div class="col-12" style="margin-top: 30px">
      <b-card-text>
        <center>
          <img src="../assets/114.jpg" height="250px" /><br />
          <!-- <h7><b>Name:cow</b></h7
          ><br />
          <h7><b>Type:</b></h7
          ><br />
          <h7><b>Amount:20000</b></h7
          ><br />
          <h7><b>Tag No:</b></h7
          ><br />
          <h7><b>Daily Milk:</b></h7> -->
        </center>
      </b-card-text>
      <table style="" width="100%" border="0">
        <br />
        <!-- <tr>
                    <td   style="text-align: left">Tag No</td>
                    <td   style="text-align: left">:</td>
                    
                    <td   style="text-align: left">29</td>
                  </tr> -->
        <tr>
          <td width="45%" style="text-align: left">Tag No</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">22</td>
        </tr>

        <tr>
          <td width="45%" style="text-align: left">Type</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">Cow</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Breed</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">Deshi</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Breed Name</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">Badri</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Age</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">7 Years</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Amount</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">30.000</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">In milking Days</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">Yes,Milking</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">milking Yeild</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">10L</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Is Pregnant</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">No</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">No of Parturition</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">2</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Pregnancy month</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">-</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Is Calveh</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">Yes</td>
        </tr>
        <tr>
          <td width="45%" style="text-align: left">Last Calve Date</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">20-07-2020</td>
        </tr>

        <tr>
          <td width="45%" style="text-align: left">Last Calve Gender</td>
          <td width="1%" style="text-align: left">:</td>
          <td width="54%" style="text-align: left">Male</td>
        </tr>

        <br />
        <tr>
          <!-- <td colspan="3" style="text-align: center">
            <button
              type="button"
              class="btn btn-xs btn-primary col-12"
              @click="viewHandle"
            >
              View Medical Certificate
            </button>
          </td> -->
        </tr>
        <br />
      </table>
      <div class="btn-group col-12">
        <button
          type="button"
          class="btn btn-xs btn-primary col-6"
          @click="send_enquiry"
        >
          Send Enquiry</button
        >&nbsp;
        <button type="button" class="btn btn-xs btn-primary col-6" @click="viewHandle">
          View Medical Certificate
        </button>
      </div>
      <br />
    </div>
    <br />
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {
    add_to_cart() {
      alert("Added To Cart");
    },
    send_enquiry() {
      alert("Enquiry send to seller");
    },
    viewHandle() {
      this.$router.push("/home/viewmedical_certificate");
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>